import { render, staticRenderFns } from "./AppItem.vue?vue&type=template&id=278c0168&scoped=true"
import script from "./AppItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppItem.vue?vue&type=style&index=0&id=278c0168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278c0168",
  null
  
)

export default component.exports